<mat-card>
  <!-- <google-map width="1600px" height="700px" [center]="center" [zoom]="zoom">
    <map-marker [position]="{lat: center.lat, lng: center.lng}"></map-marker>
  </google-map> -->
  <div #map id="map"></div>
</mat-card>